/** @jsx jsx */
import type { Theme } from '@emotion/react';
import { css, jsx, withTheme } from '@emotion/react';

import * as React from 'react';

import gql from 'graphql-tag';

import { typography2 } from '@coursera/cds-core';

import { CML } from 'bundles/cml';
import type { SecondaryDescriptionFragment as SecondaryDescriptionFragmentType } from 'bundles/collections/components/__generated__/SecondaryDescriptionFragment';
import withFragments from 'bundles/graphql/components/withFragments';

type PropsFromCDS = {
  theme: Theme;
};
type Props = PropsFromCDS & {
  secondaryDescription: SecondaryDescriptionFragmentType;
};

const styles = {
  cmlComponent: (theme: Theme) => css`
    .rc-CML {
      h2 {
        font-family: ${theme.typography.h2semibold};
      }

      p {
        font-family: ${typography2.bodyPrimary};
      }
    }
  `,
};

class CollectionSecondaryDescription extends React.Component<Props> {
  render() {
    const { secondaryDescription, theme } = this.props;

    if (!secondaryDescription) {
      return null;
    }

    const cmlNaptimeShape = secondaryDescription && {
      typeName: 'cml' as const,
      definition: {
        value: secondaryDescription.cml.value,
        dtdId: secondaryDescription.cml.dtdId,
      },
    };
    return (
      <div css={styles.cmlComponent(theme)}>
        <CML
          className="body-1-text p-y-3"
          cml={cmlNaptimeShape}
          shouldRenderMath={false}
          shouldRenderCode={false}
          shouldRenderAssets={false}
        />
      </div>
    );
  }
}

const CollectionSecondaryDescriptionFragment = gql`
  fragment SecondaryDescriptionFragment on CatalogCollectionPagesV1_secondaryDescription {
    ... on CatalogCollectionPagesV1_cmlMember {
      cml {
        value
        dtdId
      }
    }
  }
`;
const CollectionSecondaryDescriptionWithTheme = withTheme(CollectionSecondaryDescription);
export default withFragments({
  collectionSecondaryDescriptionFragment: CollectionSecondaryDescriptionFragment,
})(CollectionSecondaryDescriptionWithTheme);
